// For environment details see: https://confluence.mtvi.com/display/TCP/Global+Entry+-+execution+environment+-+Level+1+-+development

export const version = 'YYYY-MM-DD_branchName_shortHash';
export const aspera_uid = '';
export const aspera_pwd = '';
